const routes = [
  {
    path: 'zero-width-filter',
    name: 'zero-width-filter',
    component: () => import(/* webpackChunkName: "zero-width-filter" */ '@/modules/zero-width-filter/index.vue')
  },
];

export default routes;